export default __webpack_public_path__ + "static/NeueHelveticaPro57Condensed-6eafe8d2f856bd8276e9077264f99821.woff";